import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

/**
 * Common cookie names for JWT access tokens
 * Note: If cookies are HttpOnly, they won't be readable by JavaScript
 * but will still be sent automatically with API requests
 */
const POSSIBLE_ACCESS_TOKEN_COOKIE_NAMES = [
  'access_token',
  'accessToken',
  'access',
  'jwt_access_token',
  'jwt_access',
  'jwt',
  'token',
  'auth_token',
  'authToken',
]

/**
 * Reads JWT access token from cookies
 * Tries common cookie names in order
 * @returns The access token if found, null otherwise
 */
export const getAccessTokenFromCookies = (): string | null => {
  for (const cookieName of POSSIBLE_ACCESS_TOKEN_COOKIE_NAMES) {
    const token = Cookies.get(cookieName)
    if (token) {
      return token
    }
  }
  return null
}

/**
 * Gets the expiration time from a JWT access token stored in cookies
 * @returns The expiration timestamp (exp) if token is found and valid, null otherwise
 */
export const getTokenExpirationFromCookies = (): number | null => {
  const accessToken = getAccessTokenFromCookies()
  if (!accessToken) {
    return null
  }

  try {
    const decodedToken = jwtDecode(accessToken) as { exp?: number }
    return decodedToken.exp || null
  } catch (error) {
    return null
  }
}
